import { Dispatch } from 'react';
import { IAction } from 'appRedux/reducers';
import { OrderByEnum } from 'common/common';

export const AppKey = 'SLOTCHECKSPA-';
export const slotCompareActionTypes = {
  TOGGLE_SELECTED_SLOT: `${AppKey}-TOGGLE_SELECTED_SLOT`,
  START_COMPARING: `${AppKey}-START_COMPARING`,
  STOP_COMPARING: `${AppKey}-STOP_COMPARING`,
  CLEAR_SLOTS: `${AppKey}-CLEAR_SLOTS`,
  SET_SLOT_NUMBERS: `${AppKey}-SET_SLOT_NUMBERS`,
  SET_SELECTED_INSIGHT: 'SET_SELECTED_INSIGHT',
  SET_SELECTED_RANGE: 'SET_SELECTED_RANGE',
  SET_COMPARE_SORT_BY: 'SET_COMPARE_SORT_BY',

  SET_TIMEFRAME_PREFIX: 'SET_TIMEFRAME_PREFIX',
  SET_TIMEFRAME_ORDER_BY: 'SET_TIMEFRAME_ORDER_BY',
  SET_TIMEFRAME_AND_ORDER: 'SET_TIMEFRAME_AND_ORDER',
  SET_SETTINGS_ACTIVE: 'SET_SETTINGS_ACTIVE',
  SET_SELECTED_INSIGHTS: 'SET_SELECTED_INSIGHTS',
  SET_CUSTOM_DEFAULT_INSIGHTS: 'SET_CUSTOM_DEFAULT_INSIGHTS',
  REMOVE_CUSTOM_DEFAULT_INSIGHTS: 'REMOVE_CUSTOM_DEFAULT_INSIGHTS',
};
export const SlotCompareReduxCommandCreator = (dispatch: Dispatch<IAction>) => {
  return {
    toggleSelectedSlot(state: { slotNumber: number }) {
      dispatch({
        type: slotCompareActionTypes.TOGGLE_SELECTED_SLOT,
        state,
      });
    },
    startComparing(state?: { exploreInsight?: string }) {
      dispatch({
        type: slotCompareActionTypes.START_COMPARING,
        state,
      });
    },
    stopComparing() {
      dispatch({
        type: slotCompareActionTypes.STOP_COMPARING,
      });
    },
    clearSlots() {
      dispatch({
        type: slotCompareActionTypes.CLEAR_SLOTS,
      });
    },
    setSlotNumbers(state: { slotNumbers: number[] }) {
      dispatch({
        type: slotCompareActionTypes.SET_SLOT_NUMBERS,
        state,
      });
    },
    setSelectedInsight(state: { insight: string }) {
      dispatch({
        type: slotCompareActionTypes.SET_SELECTED_INSIGHT,
        state,
      });
    },
    setSelectedRange(state: { range: string }) {
      dispatch({
        type: slotCompareActionTypes.SET_SELECTED_RANGE,
        state,
      });
    },
    setSortBy(state: { compareSortBy: string }) {
      dispatch({
        type: slotCompareActionTypes.SET_COMPARE_SORT_BY,
        state,
      });
    },
    setTimeframePrefix(state: { timeframePrefix: string }) {
      dispatch({
        type: slotCompareActionTypes.SET_TIMEFRAME_PREFIX,
        state,
      });
    },
    setTimeframeOrderBy(state: { timeframeOrderBy: string }) {
      dispatch({
        type: slotCompareActionTypes.SET_TIMEFRAME_ORDER_BY,
        state,
      });
    },
    setTimeframe: (state: { timeframePrefix: string; timeframeOrderBy: OrderByEnum }) => {
      dispatch({
        type: slotCompareActionTypes.SET_TIMEFRAME_AND_ORDER,
        state,
      });
    },
    setSettingsActive(state: { settingsActive: boolean }) {
      dispatch({
        type: slotCompareActionTypes.SET_SETTINGS_ACTIVE,
        state,
      });
    },
    setSelectedInsights(state: { insights: string[] }) {
      dispatch({
        type: slotCompareActionTypes.SET_SELECTED_INSIGHTS,
        state,
      });
    },
    setCustomDefaultInsights(state: { insights: string[] }) {
      dispatch({
        type: slotCompareActionTypes.SET_CUSTOM_DEFAULT_INSIGHTS,
        state,
      });
    },
    removeCustomDefaultInsights() {
      dispatch({
        type: slotCompareActionTypes.REMOVE_CUSTOM_DEFAULT_INSIGHTS,
      });
    },
  };
};
